import { default as React } from "react";
import { put } from "aws-amplify/api";
import { Modal, Button } from "react-bootstrap";
import PropertyIntegrationsList from "containers/property/PropertyIntegrationsList";

function PropertyIntegrationsModal({
    show,
    isLoading = false,
    isAuthenticated,
    user,
    updateTableState,
    filter,
    data,
    saveRecord,
    deleteRecord,
    onClose,
    acceptIntegration,
    rejectIntegration,
    ctx,
}) {

    async function deleteAll(event) {
        if ((data || []).length === 0) {
            return;
        }

        const confirm = window.confirm('Are you sure you want to delete all Equivalent Properties?');

        if (!confirm) {
            return;
        }

        const localData = [...data].map(data => { return { ...data, archived_date: new Date().toISOString() } });

        let apiPath = null;
        if (ctx === 'cs') {
            apiPath = `/properties/${filter?.propertyid}/integrations_bulk/null`;
        } else if (ctx === 'slmsale') {
            apiPath = `/slmsales/${filter?.saleid}/integrations_bulk/null`;
        } else if (ctx === 'slmlease') {
            apiPath = `/slmleases/${filter?.leaseid}/integrations_bulk/null`;
        }

        if (!apiPath) {
            return;
        }

        try {
            const response = await put({
                apiName: "colin",
                path: apiPath,
                options: { body: localData },
            }).response;
            const result = await response.body.json();
            console.log("deleteAll result: ", result);
        } catch (error) {
            alert(error + ". Please refresh the page (F5) to try again.");
            return;
        }

        updateTableState([], 'integrations');
    }

    return (
        <Modal
            id="property-integrations-modal"
            show={show}
            onHide={onClose}
            dialogClassName="property-table-modal-wide"
        >
            <Modal.Header closeButton>
                <Modal.Title>CoreLogic Equivalent Properties</Modal.Title>
            </Modal.Header>
            <Modal.Body id="property-integrations-modal-body" style={{ overflowX: "scroll" }}>
                <div className="text-right mb-1">
                    <Button id="property-integrations-delete-all-button" type="button" size="sm" variant="danger" onClick={(e) => deleteAll(e)}>Delete All</Button>
                </div>
                <PropertyIntegrationsList
                    filter={filter}
                    isAuthenticated={isAuthenticated}
                    isLoading={isLoading}
                    controlType="table"
                    user={user}
                    data={data}
                    deleteRecord={deleteRecord}
                    acceptIntegration={acceptIntegration}
                    rejectIntegration={rejectIntegration}
                    ctx={ctx}
                />
            </Modal.Body>
        </Modal>
    );
}
export default PropertyIntegrationsModal;